// import { createStore, applyMiddleware } from "redux";
// import {thunk} from "redux-thunk";
// import { composeWithDevTools } from "redux-devtools-extension";
// import reducers from "./reducers/index";

// const initialState = {};

// const middleware = [thunk];

// const store = createStore(
//   reducers,
//   initialState,
//   composeWithDevTools(applyMiddleware(...middleware))
// );

// export default store;


import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './reducers'; // assuming you have combined reducers
import { apiSlice } from './reducers/apiSlice';
import { settingsApi } from './reducers/settingsApi';

const store = configureStore({
  reducer: rootReducer,
  devTools: true, // enables Redux DevTools
 middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: true, // (Optional) Thunk is actually enabled by default in RTK
      serializableCheck: false, // (Optional) Helps prevent warnings with large API responses
    }).concat(
      apiSlice.middleware, 
      settingsApi.middleware 
    ),
  preloadedState: {},
});

export default store;

